import { SectionHeading } from "@/components/SectionHeading";
import { RevealGroup, RevealItem } from "@/components/Reveal";
import { Icon } from "@/components/Icon";
import { securityPoints } from "@/data/content";

export default function SecuritySection() {
  return (
    <section className="bg-mist py-24 lg:py-32" data-testid="security-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="Security & Confidentiality"
          title="Your Property Information Is Treated With Care"
          subtitle="We understand that property owners may need to share business information, documents, photos, account details and operational information when setting up online listings. HM Services follows a professional and confidential approach when handling client information."
        />
        <RevealGroup className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {securityPoints.map((s) => (
            <RevealItem key={s.title}>
              <div className="flex h-full items-start gap-4 rounded-2xl border border-line bg-white p-6 shadow-float" data-testid={`security-card-${s.title.toLowerCase().replace(/\s+/g, "-")}`}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-navy text-sky">
                  <Icon name={s.icon} className="h-5 w-5" />
                </span>
                <div>
                  <h3 className="font-serif text-lg font-semibold text-navy">{s.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-slate-600">{s.desc}</p>
                </div>
              </div>
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
}
